import { Invitation, InvitationLite } from './invitation.model';

export class Candidate {
  id: number;
  randstadCandidate: string;
  name: string;
  surname1: string;
  surname2: string;
  surnameComplete: string;
  email: string;
  idCard: string;
  password: string;
  origin: string;
  status: string;
  createdAt: Date;
  updatedAt: Date;
  createdBy: string;
  updatedBy: string;
  hasInvitation: number;
  invitationsLite?: InvitationLite[];
  invitations?: Invitation[];
  acceptTerms?: number;
  clientId?: number;
}

export class CandidateSearch {
  candidateId: string;
  email: string;
  idCard: string;
  name: string;
  surname: string;
}

export class CandidateCreate {
  email: string;
  idCard: string;
  name: string;
  surname1: string;
  surname2: string;
  checked?: boolean;
  hasError?: boolean;
  hasWarning?: boolean;
}

export class CandidateRandstad {
  id: number;
  randstadCandidate: string;
}
